// Referral attribution utility
// 15-day TTL, last-click: a newer ?ref= always overwrites the previous one.

const KEY = 'karmana_referral';
const INVITE_KEY = 'karmana_invite';
const TTL_MS = 15 * 24 * 60 * 60 * 1000;

export const storeReferral = (refUserId) => {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ref: refUserId, expires: Date.now() + TTL_MS }));
  } catch { /* ignore storage errors */ }
};

export const getReferral = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (Date.now() > data.expires) { localStorage.removeItem(KEY); return null; }
    return data.ref;
  } catch { return null; }
};

export const clearReferral = () => {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
};

// Activity invite attribution — stores the inviter user id + activity id
export const storeInvite = (invitedBy, activityId) => {
  try {
    localStorage.setItem(INVITE_KEY, JSON.stringify({ invited_by: invitedBy, activity_id: activityId, expires: Date.now() + TTL_MS }));
  } catch { /* ignore */ }
};

export const getInvite = () => {
  try {
    const raw = localStorage.getItem(INVITE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (Date.now() > data.expires) { localStorage.removeItem(INVITE_KEY); return null; }
    return { invited_by: data.invited_by, activity_id: data.activity_id };
  } catch { return null; }
};

export const clearInvite = () => {
  try { localStorage.removeItem(INVITE_KEY); } catch { /* ignore */ }
};

